import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, RefreshCw, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { uploadFile } from "@/components/Uploads";

// live camera only (no gallery) so attendance must use a real face
export const CameraCapture = ({ onDone, testId = "camera" }) => {
  const video = useRef();
  const [stream, setStream] = useState(null);
  const [shot, setShot] = useState("");
  const [busy, setBusy] = useState(false);
  const start = async () => {
    try {
      const s = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user", width: 720, height: 720 }, audio: false });
      setStream(s); setShot("");
      setTimeout(() => { if (video.current) video.current.srcObject = s; }, 50);
    } catch { toast.error("Kamera tidak bisa dibuka. Izinkan akses kamera di browser."); }
  };
  useEffect(() => () => stream?.getTracks().forEach((t) => t.stop()), [stream]);
  const capture = () => {
    const v = video.current;
    const c = document.createElement("canvas");
    c.width = v.videoWidth; c.height = v.videoHeight;
    c.getContext("2d").drawImage(v, 0, 0);
    setShot(c.toDataURL("image/jpeg", 0.9));
    stream.getTracks().forEach((t) => t.stop()); setStream(null);
    setBusy(true);
    c.toBlob(async (b) => {
      try { onDone((await uploadFile("photo", new File([b], "face.jpg", { type: "image/jpeg" }))).path); } catch { toast.error("Upload foto gagal"); onDone(""); } finally { setBusy(false); }
    }, "image/jpeg", 0.9);
  };
  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="grid aspect-square w-full max-w-[280px] place-items-center overflow-hidden rounded-xl bg-slate-900 text-slate-400">
        {stream ? <video ref={video} autoPlay playsInline muted className="h-full w-full -scale-x-100 object-cover" /> : shot ? <img src={shot} alt="" className="h-full w-full object-cover" /> : <Camera className="h-10 w-10" />}
      </div>
      {stream ? <Button type="button" onClick={capture} data-testid={`${testId}-shoot-btn`}><Camera className="h-4 w-4 mr-1" />Ambil Foto</Button>
        : <Button type="button" variant="outline" disabled={busy} onClick={start} data-testid={`${testId}-open-btn`}>{busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : shot ? <RefreshCw className="h-4 w-4 mr-1" /> : <Camera className="h-4 w-4 mr-1" />}{shot ? "Ulangi Foto" : "Buka Kamera"}</Button>}
    </div>
  );
};
